module.exports = "/_next/static/images/coby-brandt@2x-237d2817e7fd815391ea24c4cf2bcb0f.png";